import React from "react";
import PropTypes from "prop-types";

/**
 * One reconciliation result: label, match %, a band-coloured progress bar and a
 * caption. `band` is pass | warn | fail | info.
 */
const ReconciliationBar = ({ label, pct, band, caption }) => {
    const width = Math.max(0, Math.min(100, Number(pct) || 0));
    return (
        <div className={"cc-recon cc-recon--" + band}>
            <div className={"cc-recon__head"}>
                <span className={"cc-recon__label"}>{label}</span>
                <span className={"cc-recon__pct"}>{pct}%</span>
            </div>
            <div className={"cc-recon__track"}>
                <div
                    className={"cc-recon__fill"}
                    style={{ width: width + "%" }}
                />
            </div>
            {caption ? (
                <div className={"cc-recon__caption"}>{caption}</div>
            ) : null}
        </div>
    );
};

ReconciliationBar.propTypes = {
    label: PropTypes.string,
    pct: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    band: PropTypes.string,
    caption: PropTypes.string
};

export default ReconciliationBar;
